<!-- Carregando a moeda do cliente (a montagem do formulário depende dela). -->
<div *ngIf="carregando" class="form-card">
  <div class="card-content">
    <div class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.itens.carregando' | translate }}</span>
    </div>
  </div>
</div>

<!-- Erro (inclui 403 de cliente sem contrato ativo). -->
<div *ngIf="!carregando && erro" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
      <p>{{ 'contador_operar.itens.erro_carregar' | translate }}</p>
      <button pButton
        [label]="'contador.dashboard.estados.tentar_novamente' | translate"
        icon="pi pi-refresh"
        class="btn-primary btn-sm"
        (click)="recarregar()">
      </button>
    </div>
  </div>
</div>

<!-- Gestão completa de itens do cliente, reusada em modo embutido (sob contexto).
     Montado só depois de a moeda do cliente chegar: sem ela o formulário
     mascararia preço/custo na moeda do CONTADOR. -->
<app-lista-de-produtos *ngIf="montado"
  [embutido]="true"
  [empresaContextoId]="clienteEmpresaId"
  [moedaCliente]="moedaCliente">
</app-lista-de-produtos>
